import Dialogs from './dialogs';
import DialogMessages from './dialog-messages';

export default Dialogs;
export { DialogMessages };
export {
  clearDialogContext,
  formatDate,
  getDialogContext,
  getDialogTitle,
  getDialogs,
} from './dialogs';
export {
  clearMessageContext,
  getDialogMessages,
  getMessage,
  updateMessageOperator,
} from './dialog-messages';
